module.exports = __webpack_public_path__ + "img/H4.ad70ef92.png";